'use client'

import { Calendar, X } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { Button } from '@/components/ui/button'
import { openCalendly } from '@/components/ui/calendly-button'
import { Heading } from '@/components/ui/heading'
import { Text } from '@/components/ui/text'
import { useModal } from './ModalContext'

export default function ModalCall() {
  const { activeModal, closeModal } = useModal()
  const isOpen = activeModal === 'call'
  const t = useTranslations('modals.call')

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-text-primary/40 backdrop-blur-sm"
        onClick={closeModal}
      />
      <div className="relative z-10 w-full max-w-2xl rounded-3xl border border-border bg-white p-8 shadow-[0_40px_80px_-20px_rgba(43,90,255,0.25)]">
        <div className="mb-6 flex items-center justify-between">
          <Heading as="h3" size="h3">{t('title')}</Heading>
          <button
            type="button"
            onClick={closeModal}
            aria-label={t('closeLabel')}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-border text-text-muted transition-colors hover:border-blue hover:text-blue"
          >
            <X size={16} strokeWidth={2} />
          </button>
        </div>

        <div className="flex flex-col items-center gap-5 rounded-2xl border border-border bg-bg-off px-6 py-10 text-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-grad-cta text-white shadow-[0_10px_30px_-10px_rgba(43,90,255,0.5)]">
            <Calendar size={28} strokeWidth={1.75} />
          </div>
          <Text tone="muted" className="max-w-md">
            {t('calendarText')}
          </Text>
          <Button
            size="lg"
            onClick={() => {
              closeModal()
              openCalendly()
            }}
          >
            {t('calendarCta')} <span aria-hidden>→</span>
          </Button>
        </div>
      </div>
    </div>
  )
}
